import { useSelector } from "react-redux";
import { HELP_CENTER_PATH, HELPDESK_TICKETS_PATH } from "@/shared/configs/routes.config";
import type { RootState } from "@/store";

// Le Centre d'aide s'ouvre par un interrupteur API (YTI-1904) : une clé absente vaut fermé.
export const useHelpCenterEnabled = (): boolean =>
  useSelector((state: RootState) => state.session.user?.representative?.help_center_enabled === true);

// Entrée « Centre d'aide » : la FAQ si elle est ouverte, sinon directement les tickets.
export const useHelpEntryPath = (): string =>
  useHelpCenterEnabled() ? HELP_CENTER_PATH : HELPDESK_TICKETS_PATH;
